import { useState } from 'react';
import './style.scss';

import ButtonCTA from '../UI Elements/ButtonCTA/ButtonCTA';

import { AddressItem } from '@global/components/AddressDoctor/AddressItem';
import { ModalContent } from '@global/hooks/useModal/useModal';
import { Country } from '@global/types/types';
import { useTranslation } from 'react-i18next';
import { CountryService } from '@global/utils/CountryService';
import { Address } from './types';

export const AddressDoctor: ModalContent<Address[]> = ({
  handleClose,
  customData,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(0);

  const handleSelect = (index: number) => {
    setSelected(index);
  };

  const onSubmit = async () => {
    await handleSubmit(customData[selected]);
    handleClose();
  };

  const [currentData, ...restData] = customData;

  const currentState = CountryService.getStateByIsoCode(
    (currentData.country as Country).regions,
    currentData.state
  );

  const getStateByIsoCode = (state) => {
    return CountryService.getStateByIsoCode(
      (currentData.country as Country).regions,
      state
    );
  };

  return (
    <div>
      <header className="address-doctor__header">
        <h3 className="address-doctor__title">{t('addressDoctor.title')}</h3>
        <p className="address-doctor__subtitle">
          {t('addressDoctor.subtitle')}
        </p>
      </header>

      <div className="address-doctor__content-wrapper">
        <AddressItem
          title={t('addressDoctor.title3')}
          isShowEditBtn={true}
          addressInfo={{ ...currentData, state: currentState?.name || '' }}
          index={0}
          selected={selected === 0}
          handleSelect={handleSelect}
          handleClose={handleClose}
        />

        <h4 className="address-doctor__list_title">
          {t('addressDoctor.title2')}
        </h4>
        <ul className="address-doctor__list">
          {restData?.map((addressInfo, index) => (
            <AddressItem
              key={addressInfo.uid + String(index)}
              addressInfo={{
                ...addressInfo,
                state: getStateByIsoCode(addressInfo.state)?.name,
              }}
              index={index + 1}
              handleSelect={handleSelect}
              selected={selected === index + 1}
            />
          ))}
        </ul>
      </div>

      <ButtonCTA
        variant="primary"
        className="address-doctor__cta"
        onClick={onSubmit}
      >
        {t('addressDoctor.action')}
      </ButtonCTA>
    </div>
  );
};
